import Typography from '@classify/react-core-components/Typography';
import { makeStyles } from '@mui/styles';
import { translate } from '@openclassrooms/translations';
import Skeleton from '@classify/react-core-components/Skeleton';
import learningOutcomesPassed from '../images/learning-outcomes-passed.svg';

const useStyles = makeStyles(({ spacing }) => ({
  title: {
    marginBottom: spacing(1),
  },
  hStack: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '& > * + *': {
      marginLeft: spacing(1),
    },
  },
}));

export interface LearningOutComeProps {
  value: number;
  max: number;
  isLoading: boolean;
}
function LearningOutcome({ value, max, isLoading }: LearningOutComeProps) {
  const classes = useStyles();

  return (
    <div>
      <Typography component="span" variant="overline" className={classes.title}>
        {translate('course.in_progress.learning_outcomes.label')}
      </Typography>

      <div className={classes.hStack}>
        <span>
          <img src={learningOutcomesPassed} alt="" height="32px" width="32px" />
        </span>
        <span data-testid="learning-outcome" aria-busy={isLoading}>
          {isLoading ? (
            <Skeleton width={60} />
          ) : (
            <>
              <Typography variant="h3" component="span" display="inline">
                {value}
              </Typography>
              <Typography
                variant="h5"
                component="span"
                style={{ fontWeight: 'normal' }}
                display="inline"
              >
                /{max}
              </Typography>
            </>
          )}
        </span>
      </div>
    </div>
  );
}

export default LearningOutcome;
